import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Logo as PlatformLogo } from '@xingternal/platform-layout-logo';
import { CenterContainer } from '@xingternal/platform-layout-view-wrapper';

import { SubHeader } from './SubHeader';
import styles from './CheckoutHeader.css';

const Logo = ({ homeLink }) => {
  return (
    <div className={cx(styles.logoWrapper)}>
      <PlatformLogo
        butterfly
        className={cx(styles.logo, styles.butterfly)}
        homeLink={homeLink}
        dataQa="logoMobile"
        size={28}
      />
      <PlatformLogo
        className={cx(styles.logo, styles.duoLogo)}
        variant="duo"
        size={96}
        homeLink={homeLink}
        dataQa="logo"
      />
    </div>
  );
};

Logo.propTypes = {
  homeLink: PropTypes.string,
};

const CheckoutHeader = ({ homeLink }) => {
  return (
    <div className={styles.headerPlacebo}>
      <header className={styles.headerWrapper}>
        <CenterContainer className={styles.header}>
          <div className={styles.logoWrapper}>
            <Logo homeLink={homeLink} />
          </div>

          <SubHeader homeLink={homeLink} />
        </CenterContainer>
      </header>
    </div>
  );
};

CheckoutHeader.defaultProps = { type: 'standard' };

CheckoutHeader.propTypes = {
  helpLink: PropTypes.string,
  homeLink: PropTypes.string,
  loginLink: PropTypes.string,
  signupLink: PropTypes.string,
};

export { CheckoutHeader };
